import React from 'react';
import { Logo } from './Logo';
import { Cta } from './Cta';
import { useScore } from './ScoreContext';
export function Nav() {
  const {
    answeredCount,
    openDiagnostic
  } = useScore();
  const ctaLabel = answeredCount === 0 ? 'Get Your Reader-to-Revenue Score' : answeredCount < 4 ? 'Continue Your Score' : 'Finish Your Score';
  return <header className="sticky top-0 z-40 w-full border-b border-gray-100 bg-paper/80 shadow-sm backdrop-blur-md" data-id="element-309" data-mp="1b1xbw3hvqq08">
      <div className="mx-auto flex w-full max-w-[90rem] items-center justify-between gap-3 px-5 py-3 md:px-8 md:py-5 lg:px-10" data-id="element-310" data-mp="1fxkyqc8w372k">
        <Logo data-id="element-311" data-mp="1ppqp5hjhtgfn" />
        <Cta variant="primary" onClick={openDiagnostic} className="max-w-[58%] shrink px-3 py-2 text-xs leading-snug shadow-sm hover:shadow sm:max-w-none sm:px-5 sm:py-2.5 sm:text-sm md:text-sm" data-id="element-312" data-mp="1pp8o87lvye1e">
          {ctaLabel}
        </Cta>
      </div>
    </header>;
}